import { scaleLinear } from 'd3'
import styled from 'styled-components'
import { useElementSize, useWindowSize } from 'usehooks-ts'
import { SVGDefs } from '../SVGDefs'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const ColorKey = ({
  values,
  colorMode,
}: {
  values: { label: number; color: string; size: number }[]
  colorMode?: 'light' | 'dark' | undefined
}) => {
  const { t } = useTranslation()
  const { width } = useWindowSize()
  const [elementRef, elementSize] = useElementSize()
  var x = scaleLinear()
    .domain([0, values.map((v) => v.size).reduce((a, b) => a + b, 0)])
    .range([0, elementSize.width - 10])

  let currentX = 0
  return (
    <ColorKeyRoot ref={elementRef}>
      <ColorKeySvg
        style={{ width: width > 711 ? '370' : width - 40 }}
        colorMode={colorMode}
      >
        <SVGDefs />
        {values.map((v, i) => {
          var thisx = currentX
          currentX += x(v.size)
          const thisw = i == 0 ? 0 : x(v.size)
          return (
            <g transform={`translate(${thisx},${20})`} key={'colorkey_' + i}>
              <rect x={2} height={10} width={thisw - 4} fill={'#fff'} />
              <rect x={2} height={10} width={thisw - 4} fill={v.color} />
              <text
                x={i === 0 ? 5 : thisw}
                y={-4}
                textAnchor={
                  i === 0 ? 'start' : i === values.length - 1 ? 'end' : 'middle'
                }
              >
                {v.label + (i === values.length - 1 ? '%' : '')}
              </text>
            </g>
          )
        })}
        <g transform={`translate(${5},${35})`}>
          <rect
            width={12}
            height={12}
            fill='#fff'
            // stroke={'var(--gray-3)'}
          />
          <text x={20} y={10.5}>
            {t("swissmap:noData")}
          </text>
        </g>
      </ColorKeySvg>
    </ColorKeyRoot>
  )
}

const Info = styled.div`
  font-size: 12px;
  line-height: 1.2em;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;

  pointer-events: none;
  overflow: hidden;
  transition: all 0.2s ease-out;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`

const ColorKeyRoot = styled.div`
  position: absolute;
  top: -60px;
  left: 50%;
  color: var(--text-color);
  transform: translateX(-50%);
  pointer-events: none;
  @media screen and (max-width: 711px) {
    bottom: -80px;
  }
`
const ColorKeySvg = styled.svg<{ colorMode: 'dark' | 'light' | undefined }>`
  height: 80px;
  width: 368px;
  overflow: visible;
  max-width: 100vw;
  font-size: 12px;
  text {
    font-size: 12px;
    fill: ${(props) =>
      props.colorMode == 'dark' ? '#e7e7e7' : 'var(--gray-2);'};
  }
`
